import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const PageContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
        margin-top: ${(props) =>
            props.filterDataOpen ? '-0.75rem' : '-1.5rem'};
        position:relative;
        height: ${(props) =>
            props.accountSearchOpen || props.filterDataOpen
                ? 'calc(100vh - 180px)'
                : '100%'};
    `}
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        padding-top: 10px;
        justify-content: space-between;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      padding ? padding : '1.125rem'
                  }, calc(4*env(safe-area-inset-bottom)))`
                : padding
                ? padding
                : '1.125rem'} 
    `}
`;

export const PaginationContainer = styled.div`
    position: absolute;
    width: 99.7%;
    height: 50px;
    margin-top: 3px;
    background-color: white;
    box-shadow: 0px -3px 6px #00000014;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;

    .p-paginator {
        padding: 0.5rem 0.5rem;
        ${media.mediumDevice`    
            padding: 0.5rem 1rem;
        `}
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        padding-right: 20px;
        padding-left: 10px;
        height: 50px;
    }
    ${media.mediumDevice`    
        box-shadow: none;
        border-radius: none;
        padding-right: 55px;
        padding-left: 10px;
    `}
    ${media.smalDevice`    
        padding-right: 55px;
        padding-left: 10px;
    `}
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        box-shadow: none;
        border-radius: none;        
    `}
`;

export const DesktopView = styled.div`
    display: block;
    position: relative;
    position: fixed;
    max-width: 1090px;
    width: 100%;
    padding-bottom: ${(props) =>
        props.showDoubleBanner
            ? '50px'
            : props.showSingleBanner
            ? '50px'
            : '0px'};

    bottom: ${(props) =>
        props.showDoubleBanner
            ? '0px'
            : props.showSingleBanner
            ? '0px'
            : '50px'};

    @media only screen and (max-width: 1200px) {
        max-width: 980px;
    }

    @media only screen and (max-width: 1140px) {
        max-width: 930px;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        max-width: 970px;
    }

    @media only screen and (max-width: 1100px) {
        max-width: 924px;
    }

    @media only screen and (max-width: 1085px) {
        max-width: 890px;
    }
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
        padding-bottom: ${(props) =>
            props.showDoubleBanner
                ? '50px'
                : props.showSingleBanner
                ? '50px'
                : '0'};
        width: 100% !important;
    }

    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        position: fixed;
        max-width: 924px;
        bottom: ${(props) =>
            props.showDoubleBanner
                ? '0px'
                : props.showSingleBanner
                ? '0px'
                : '50px'};
    }
    ${media.mediumDevice`    
        position: fixed;
        width: 100%;
        max-width: 924px; 
        bottom: ${(props) =>
            props.showDoubleBanner
                ? '0px'
                : props.showSingleBanner
                ? '0px'
                : '50px'};
    `}
    ${media.smalDevice`    
        position: fixed;
        width: 100%;
        max-width: 924px; 
    `}
    
    ${media.mobileDevice`
        display: none;
    `}
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        background-color: #FFFFFF;
        box-shadow: 0px -3px 6px #00000014;
        position: fixed;
        width: 100%;
        bottom: 0;
        margin: 0 auto;
    `}
`;

export const AdminListContainer = styled.div`
    position: relative;
    background: #f5f5f5;
    overflow-y: scroll;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    border-radius: 6px;
    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: ${({ theme }) => theme.scrollOption.width};
    }
    &::-webkit-scrollbar-track {
        margin-top: 0px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
    }
    ${media.mediumDevice`
        &::-webkit-scrollbar {
            display:  none;  
        }
    `}
    ${media.smalDevice`
        flex-direction: column;
    
        &::-webkit-scrollbar {
            display:  none; }`}

    ${media.mobileDevice`
        display: block;
        border-top-left-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? '25px' : '25px'};
        border-top-right-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? '25px' : '25px'};
        box-shadow:none;
        padding: 15px 15px 15px 15px;
        border-bottom-left-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        border-bottom-right-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 360px)'
                : props.showSingleBanner
                ? 'calc(100vh - 280px)'
                : 'calc(100vh - 149px)'};
        margin-top: ${(props) => (props.filterDataOpen ? '15px' : '30px')};
        overflow: hidden;
        overflow-y: scroll;
        &::-webkit-scrollbar {
            display: ${({ theme }) => theme.scrollOption.show};
            width: 5px;
        }
        &::-webkit-scrollbar-track {
            margin-top: 15px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({ theme }) => theme.scrollOption.thumb_color};
            border-radius: ${({ theme }) => theme.scrollOption.border_radius};
            height: 7rem;
        }
    `}
`;

export const HR = styled.hr`
    position: absolute;
    left: 0;
    right: 0;
    top: 120px;
    z-index: -1;
    width: 100%;
    border: 1px solid #707070;
    opacity: 0.2;
    background-color: #707070;
    ${media.mobileDevice`
        display: none;
    `}
`;
